import { useState, useRef, useEffect } from "react"
import cx from "classnames"
import { Preset } from "@/hooks/presets"
import { ReactComponent as OptionsIcon } from "@/icons/options-icon.svg"
import { toast } from "react-toastify"

const PresetOptionsMenu = ({
  preset,
  activePreset,
  activePresetOutdated,
  onDeletePresetClicked,
  onRenamePresetClicked,
  onSavePresetClicked,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const isActivePreset = preset.id === activePreset?.id

  const options = [
    { value: "rename", label: "Edit" },
    ...(isActivePreset ? [{ value: "update", label: "Update" }] : []),
    { value: "share", label: "Share" },
    { value: "delete", label: "Delete" },
  ]

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const onMenuTriggerClicked = (e) => {
    e.stopPropagation()
    setIsOpen(true)
  }

  const onMenuOptionClicked = (e, value) => {
    e.stopPropagation()
    setIsOpen(false)

    if (value === "delete") {
      onDeletePresetClicked(preset)
    } else if (value === "rename") {
      onRenamePresetClicked(preset)
    } else if (value === "update") {
      onSavePresetClicked(preset)
    } else if (value === "share") {
      // Generate shareable URL with preset ID
      const shareUrl = `${window.location.origin}${window.location.pathname}?preset=${preset.id}`
      navigator.clipboard.writeText(shareUrl)
      toast.success("Share link copied to clipboard")
    }
  }

  return (
    <div className="relative">
      <div className="inline-block" ref={dropdownRef}>
        <OptionsIcon
          className={cx("h-3.5 w-3.5", isOpen ? "text-red" : "text-ghost")}
          onClick={onMenuTriggerClicked}
        />
        {isOpen && (
          <div
            className="absolute -right-[9px] z-10 mt-1 w-24 overflow-hidden rounded border border-earth bg-mine-shaft px-1 py-1.5 shadow-lg"
            role="button"
            aria-label="Open preset menu"
          >
            {options.map(({ label, value }) => (
              <div
                key={value}
                onClick={(e) => onMenuOptionClicked(e, value)}
                className="cursor-pointer rounded-sm px-2 py-2px text-left font-bulo text-[11px] font-medium text-white hover:bg-dark hover:text-white"
              >
                {label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default PresetOptionsMenu
